import { ContentCryptocurrency } from "./style";

export const Cryptocurrency = () => {
  return (
    <ContentCryptocurrency>
      <a id="criptomonedas"/>
      <div className="iframeCripto">
        <iframe        
          frameBorder="0"
          width="100%"
          src="https://s3.amazonaws.com/bitex-widgets/clarin/index.html"
        ></iframe>
      </div>
    </ContentCryptocurrency>
  );
};
